import { COLOR, FONT_WEIGHT, Heading as _Heading, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { ROOT_PADDING } from "~/styles/padding";

export const Heading = styled(_Heading)`
  padding: 0 ${ROOT_PADDING.PC}px;
  margin-bottom: 8px;
  color: ${COLOR.GRAY900.code};
  font-weight: ${FONT_WEIGHT.BOLD};

  ${mq.sp} {
    padding: 0 ${ROOT_PADDING.SP}px;
  }
`;
